import { ClearLastEmotionEntryAsync } from "./PlayerMenu/ClearLastEmotionEntry";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import * as React from "react";
import { SignOut } from "source/app/infrastructure/Authorizer/SignOut";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import RPGIcon from "source/app/presentation/Shared/RPGIcon/RPGIcon";
import Login from "source/app/presentation/Login/Login";
import Player from "source/app/domain/Player";
import { ShowChangePassword } from "source/app/presentation/Header/Tools/ChangePassword/ChangePassword";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import {
    SwitchDeviceMode,
    ToggleDeviceModeState,
} from "source/app/presentation/Header/Tools/DeviceMode/ToggleDeviceMode";
import { ShowDeepWorkKipsToday } from "source/app/presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsToday";
import { accountIconStyleClass, accountChevronStyleClass, AccountToggle, Container, GetDropDownContentStyleClass } from "./PlayerMenu/PlayerMenuStyles";
import { MenuItem } from "./PlayerMenu/MenuItem";
import { CompactFontSwitcher } from "./PlayerMenu/Preferences";
import { GameOptionsMenu } from "./PlayerMenu/GameOptionsMenu";
import { ClientVersion } from "./PlayerMenu/ClientVersion";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import { HandleEmotionSelectedLocallyAsync } from "source/app/presentation/BottomBar/EmotionSelector/HandleEmotionSelected/HandleEmotionSelected";

const PlayerMenu = () => {
    if (Player.IsSignedIn) {
        return <AuthMenu />;
    } else {
        return (
            <Login />
        );
    }
};

export default PlayerMenu;

interface IAuthMenuState {
    showMenu: boolean;
    showGameOptions: boolean;
}

class AuthMenu extends React.Component<{}, IAuthMenuState> {
    private dropdownRef: React.RefObject<HTMLSpanElement>;

    constructor(props: {}) {
        super(props);

        this.state = {
            showMenu: false,
            showGameOptions: false,
        };

        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    render() {
        return (
            <Container
                id="authTools"
                className="inlineStatistic btnSignOut"
                ref={this.dropdownRef}
            >
                <ToggleDeviceModeState />
                <AccountToggle
                    $isOpen={this.state.showMenu}
                    whenClicked={() =>
                        this.setState({ showMenu: !this.state.showMenu })
                    }
                    tooltip="Account"
                >
                    <RPGIcon icon={ERPGIcon.player} withClass={accountIconStyleClass} />
                    <Glyphicon
                        icon={EGlyphicon["chevron-down"]}
                        withClass={accountChevronStyleClass}
                    />
                </AccountToggle>
                <div
                    className={GetDropDownContentStyleClass(
                        this.state.showMenu
                    )}
                >
                    <MenuItem
                        onSelect={this.closeMenu}
                        icon={EGlyphicon.trash}
                        label="Clear last emotion entry"
                        onClick={ClearLastEmotionEntryAsync}
                    />
                    <MenuItem
                        onSelect={this.closeMenu}
                        icon={EGlyphicon.plus}
                        label="Record I+ max score"
                        onClick={() => HandleEmotionSelectedLocallyAsync(Emotions.IntegratedPlus)}
                    />
                    <CompactFontSwitcher />
                    <MenuItem
                        onSelect={this.closeMenu}
                        icon={EGlyphicon.lock}
                        label="Change password"
                        onClick={ShowChangePassword}
                    />
                    <MenuItem
                        onSelect={this.closeMenu}
                        icon={EGlyphicon["log-out"]}
                        label="Sign out"
                        onClick={SignOut}
                    />
                    <GameOptionsMenu
                        onSelect={this.closeMenu}
                        isOpen={this.state.showGameOptions}
                        onToggle={() =>
                            this.setState({
                                showGameOptions: !this.state.showGameOptions,
                            })
                        }
                    />
                    <MenuItem
                        onSelect={this.closeMenu}
                        icon={EGlyphicon.dashboard}
                        label="Today's Deep Work"
                        onClick={ShowDeepWorkKipsToday}
                    />
                    <MenuItem
                        onSelect={this.closeMenu}
                        icon={
                            IsMobileDevice()
                                ? EGlyphicon.picture
                                : EGlyphicon.phone
                        }
                        label={`Switch to ${
                            IsMobileDevice() ? "desktop" : "mobile"
                        } mode`}
                        onClick={SwitchDeviceMode}
                    />
                    <ClientVersion />
                </div>
            </Container>
        );
    }

    private closeMenu = () => {
        this.setState({ showMenu: false, showGameOptions: false });
    };

    private handleClickOutside = (event: MouseEvent) => {
        if (
            this.dropdownRef.current &&
            !this.dropdownRef.current.contains(event.target as Node)
        ) {
            this.closeMenu();
        }
    };
}
